export type ProjectMode = 'product_driven' | 'content_driven' | 'script_import'

export const PROJECT_MODE_OPTIONS: Array<{ value: ProjectMode; label: string; description: string }> = [
  {
    value: 'product_driven',
    label: '产品驱动型',
    description: '适合已经有明确产品需求、卖点和传播目标的项目。',
  },
  {
    value: 'content_driven',
    label: '内容驱动型',
    description: '适合想先做故事、段子或内容创意，再把产品自然带进去的项目。',
  },
  {
    value: 'script_import',
    label: '剧本直入型',
    description: '适合已经有剧本初稿，想直接从剧本修订审批开始推进的项目。',
  },
]

export const CONTENT_TYPE_OPTIONS = [
  '短剧',
  '反转',
  '暖心',
  '狗血',
  '悬疑',
  '校园小故事',
  '职场小故事',
  '治愈',
  '伤感',
  '沙雕',
  '段子',
  '趣味',
  '生活趣事',
  '脑洞整活',
] as const

export type ContentType = typeof CONTENT_TYPE_OPTIONS[number]

export const CONTENT_SOURCE_LABELS: Record<string, string> = {
  system_content_library: '素材参考中心复用',
  llm_generated: '大模型生成',
  llm_generated_custom_prompt: '自定义 Prompt 生成',
  manual_confirmed: '人工确认收录',
  template_fallback: '系统兜底',
}

export function getProjectModeLabel(mode?: string | null): string {
  if (mode === 'script_import') {
    return '剧本直入型'
  }
  if (mode === 'content_driven') {
    return '内容驱动型'
  }
  if (mode === 'product_driven') {
    return '产品驱动型'
  }
  return '未设置'
}

export function getContentSourceLabel(source?: string | null): string {
  if (!source) {
    return '未生成'
  }
  return CONTENT_SOURCE_LABELS[source] || source
}